<template>
  <div id="app">
    <nav-bar v-if="!viewing"></nav-bar>

    <messages v-if="error"></messages>

    <maintenance></maintenance>

    <button
      id="goBottom"
      v-show="scrollPosition < scrollHeight"
      class="go-to has-background-warning has-text-white has-text-centered"
      @click="goTo(1)">

      <span class="icon">
        <i class="fas fa-chevron-down fa-2x"></i>
      </span>
    </button>

    <div class="container">
      <div class="columns">
        <div class="column">
          <router-view/>
        </div>
      </div>
    </div>

    <button
      id="goTop"
      v-show="scrollPosition > 200"
      class="go-to has-background-warning has-text-white has-text-centered"
      @click="goTo(0)">

      <span class="icon">
        <i class="fas fa-chevron-up fa-2x"></i>
      </span>
    </button>

    <div
      v-if="auth && processes.length > 0"
      id="processes-index"
      class="box has-background-grey-lighter">
      <processes></processes>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import NavBar from '@/components/nav/NavBar'
import Messages from '@/components/messages/Messages'
import Processes from '@/components/processes/Processes'
import Maintenance from '@/components/modules/Maintenance'

export default {
  name: 'App',
  components: {
    NavBar,
    Messages,
    Processes,
    Maintenance
  },
  data () {
    return {
      views: [
        'view-report',
        'public-page'
      ],
      scrollPosition: 0
    }
  },
  computed: {
    ...mapGetters({
      auth: 'account/auth',
      error: 'http/error',
      account: 'account/account',
      processes: 'processes/processes'
    }),
    viewing () {
      return this.views.includes(this.$route.name)
    },
    forgotPassword () {
      return this.$route.name === 'forgot-password'
    },
    scrollHeight () {
      return document.body.scrollHeight
    },
    windowHeight () {
      return window.innerHeight
    }
  },
  created () {
    let self = this

    this.$store.dispatch('http/getMaintenanceStatus')

    bus.$on('apiError', (payload) => {
      self.$store.dispatch('http/handleError', {
        'status': payload.status,
        'errors': payload.data.errors
      })
    })

    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goTo (direction) {
      const to = (direction === 1) ? document.body.scrollHeight : 0
      window.scrollTo(0, to)
    },
    handleScroll () {
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop
      this.$store.commit('screen/SET_SCROLL_POSITION', this.scrollPosition)
    }
  }
}

</script>

<style lang="scss">
  @import '~bulma/bulma.sass';
  @import '~bulma-switch';

  html {
    overflow-x: auto;
    scroll-behavior: smooth;
  }

  body {
    padding-bottom: 50px;
  }

  #app {
    margin-top: 100px;
  }

  #processes-index {
    position: fixed;
    right: 15px;
    top: 75px;
    width: 20%;
    padding: 15px;
    border-radius: 5px;
  }

  @media print {
    .no-print { display: none; }
  }

  .go-to {
    position: fixed;
    right: 20px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    line-height: 66px;
    border: 0;
    box-shadow: rgba(0, 0, 0, 0.3) 1px 1px 2px;
  }

  #goBottom {
    height: 50px;
  }

  #goTop {
    bottom: 20px;
  }

  #contentWrapper .table table {
    width: inherit;
  }
</style>
